import { QUERY_RATINGS } from "./constants";

const initialState = {};

const handleQuery = (state, action) => {
  const { type, data, payload: { params } } = action;
  const id = params.id;
  const prevResult = state[id] ? state[id].result : undefined;
  const content = {
    result: (data instanceof Array && data) || prevResult,
    data,
    [type]: true
  };
  const nextState = { ...state, [id]: content };
  return nextState;
};

const reducers = {
  [QUERY_RATINGS.SUCCESS]: handleQuery,
  [QUERY_RATINGS.PENDING]: handleQuery,
  [QUERY_RATINGS.ERROR]: handleQuery
};

export default (state = initialState, action) => {
  const { type } = action;
  const handler = reducers[type];
  if (handler) {
    return handler(state, action);
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/app/ratings/reducers.js